import { render, staticRenderFns } from "./Our4StepProcess.vue?vue&type=template&id=92588608&scoped=true&"
import script from "./Our4StepProcess.vue?vue&type=script&lang=ts&"
export * from "./Our4StepProcess.vue?vue&type=script&lang=ts&"
import style0 from "./Our4StepProcess.vue?vue&type=style&index=0&id=92588608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92588608",
  null
  
)

export default component.exports